import { useCallback, type FC } from "react";
import { Group, Button } from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { captureEvent } from "../../../utils/posthog.js";
import { Event } from "../../../constants/events.js";
import { useNavigate } from "@tanstack/react-router";
import { useSessionAccountName } from "../../../hooks/user.js";

interface LimitExceededProps {
  limitOfWhatExceeded: string;
}

export const LimitExceeded: FC<LimitExceededProps> = ({ limitOfWhatExceeded }) => {
  const navigate = useNavigate();
  const accountName = useSessionAccountName();

  if (!accountName) throw new Error("useSessionAccountName hook failed.");

  const handleNavigate = useCallback(() => {
    captureEvent(Event.NavigateFromPaymentRequiredAlert);
    void navigate({
      to: "/$accountName/admin/billing",
      params: { accountName },
      search: {
        tab: "payments",
      },
    });
  }, [accountName, navigate]);

  return (
    <Group gap="sm" wrap="wrap" align="center">
      <FormattedMessage
        id="error.limitExceeded"
        defaultMessage="Hey, you have reached your maximum number of {limitOfWhatExceeded}. Add a payment method to continue."
        values={{ limitOfWhatExceeded }}
      />
      <Button
        variant="tertiary"
        onClick={handleNavigate}
      >
        <FormattedMessage
          id="button.addPayments"
          defaultMessage="Add payment"
        />
      </Button>
    </Group>
  );
};
